// ============================================================
// AUTO-GENERATED by scripts/seed-boundaries.ts — DO NOT EDIT BY HAND.
//
// Real, recently-played play-area boundaries extracted from
// replays/*.json (the post-round replay writer persists
// session.boundary). These seed the authoring studio's default map
// (BOLT-007/012) — no GPS required — and form the "pre-saved map
// polygons" library. Regenerate with: npx tsx scripts/seed-boundaries.ts
// ============================================================
import type { Boundary } from '../../protocol';

export interface SeedBoundary {
  id: string;
  name: string;
  source: string; // the replay it came from
  boundary: Boundary;
}

export const SEED_BOUNDARIES: SeedBoundary[] = ([
  {
    "id": "craig-ranch-north",
    "name": "Craig Ranch North",
    "source": "replays/26KC2H-r0.json",
    "boundary": {
      "type": "Feature",
      "properties": {},
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -96.72716705692612,
              33.15922631250379
            ],
            [
              -96.72666269723538,
              33.157005685154346
            ],
            [
              -96.72681213714397,
              33.15525416476335
            ],
            [
              -96.72587813771631,
              33.15312727154894
            ],
            [
              -96.72541113800246,
              33.15215764135026
            ],
            [
              -96.7156202505179,
              33.152093519365735
            ],
            [
              -96.71572227307436,
              33.15918004752473
            ],
            [
              -96.72716705692612,
              33.15922631250379
            ]
          ]
        ]
      }
    }
  }
] as unknown) as SeedBoundary[];

/** The authoring studio's default map (the most recent real play area). */
export const DEFAULT_BOUNDARY: SeedBoundary = SEED_BOUNDARIES[0];
